import React from "react";
import { CampSite } from './types';



interface CampSiteDetailProps {
  campsite: CampSite;
  onEdit: (campsite: CampSite) => void;
  onDelete: (id: number) => void;
  onClose: () => void;
}

const CampSiteDetail: React.FC<CampSiteDetailProps> = ({ campsite, onEdit, onDelete, onClose }) => {
  const handleDelete = (id: number) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      onDelete(id);
      onClose();
    }
  };

  return (
    <div className="campsite-detail">
      <h2>{campsite.name}</h2>
      <p><strong>Location:</strong> {campsite.location}</p>
      <p><strong>Capacity:</strong> {campsite.capacity}</p>
      <p><strong>Price per Night:</strong> €{campsite.pricePerNight}</p>
      <p><strong>Description:</strong> {campsite.description}</p>
      <div className="campsite-images">
        {campsite.imageUrls && campsite.imageUrls.map((image, index) => (
          <img key={index} src={image.url} alt={`Campsite ${index + 1}`} />
        ))}
      </div>
      <div className="campsite-actions">
        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => onEdit(campsite)}>
          <i className="fas fa-edit"></i> Edit
        </button>
        <button className="btn btn-sm btn-outline-danger me-2" onClick={() => handleDelete(campsite.id!)}>
          <i className="fas fa-trash-alt"></i> Delete
        </button>
        <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
          <i className="fas fa-times"></i> Close
        </button>
      </div>
    </div>
  );
};

export default CampSiteDetail;